import React from 'react';
import { connect } from 'react-redux';
import { fetchSmartRecommendationData } from '../../../../dataFetchers/smartRecommendationDataFetcher';
import { onViewRecos } from '../../../../dataFetchers/recoDataFetcher.js';
import SmartRecommendation  from './SmartRecommendation';
import { getBECompatibleFuelType } from '../../../../helpers/helper';


class SmartRecommendationContainer extends React.Component {

    viewed = false;

    componentDidMount() {
        if(!this.props.smartRecommendationData.data){
            this.props.fetchSmartRecommendationData(this.props.userId, getBECompatibleFuelType(this.props.configs.data['fuelType']));
        }
    }

    onHoverReco() {
        if (!this.viewed) {
            this.props.onViewRecos(this.props.userId, this.props.smartRecommendationData.data.recoMeta.recommendationId);
            this.viewed = true;
        }
    }

    render() {
        const recoInsightEnabled = this.props.configs.data["DASHBOARD.RECO_INSIGHTS_ENABLED"] === "true";
        return(
          this.props.smartRecommendationData.data && 
          <SmartRecommendation smartRecommendationData={this.props.smartRecommendationData} onHoverReco={() => this.onHoverReco()}
            configs={this.props.configs.data} recoInsightEnabled={recoInsightEnabled} userId={this.props.userId} />
        )
    }
}

const mapStateToProps = state => {
    return{
        userId : state.userIdentityDetails.userId,
        smartRecommendationData: state.smartRecommendationData,
        configs : state.configs
    }
}

const mapDispatchToProps = dispatch => {
    return{
        fetchSmartRecommendationData : (userId, fuelType) => dispatch(fetchSmartRecommendationData(userId, fuelType)),
        onViewRecos: (userId, recoType) => dispatch(onViewRecos(userId, recoType))  
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SmartRecommendationContainer);